const keyCheck = e => {
  if ([8, 9, 27, 13, 190, 32, 43].indexOf(e.which) !== -1 ||
  // Allow: Ctrl/cmd+A
  (e.which === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
  // Allow: Ctrl/cmd+C
  (e.which === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
  // Allow: Ctrl/cmd+X
  (e.which === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
  // Allow: home, end, left, right
  (e.which >= 35 && e.which < 39)) {
  // let it happen, don't do anything
    return;
  }
  // Ensure that it is a number and stop the keypress
  if (e.which < 48 || e.which > 57) {
    e.preventDefault();
  }
};

let target;

const PhoneNumber = {
  bind(el) {
    if (el) {
      if (el.nodeName.toLowerCase() !== 'input') {
        [target] = el.getElementsByTagName('input');
      } else {
        target = el;
      }
      target.addEventListener('keypress', keyCheck);
    }
  },
  unbind(el) {
    if (el.nodeName.toLowerCase() !== 'input') {
      [target] = el.getElementsByTagName('input');
    } else {
      target = el;
    }
    target.removeEventListener('keypress', keyCheck);
  },
};

export default PhoneNumber;



// WEBPACK FOOTER //
// ./src/directives/PhoneNumber.js